module.exports = __webpack_public_path__ + "assets/img/Eimele-1-Landing-Page-w960.25f21918.jpg";